<template>
  <v-container class="limited">
    <dados-beneficiario></dados-beneficiario>
    <extrato-despesa-grid
      :codigo-beneficiario="dadosBeneficiario.id"
    ></extrato-despesa-grid>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import DadosBeneficiario from "@/components/BeneficiaryData";
import ExtratoDespesaGrid from "./extrato-despesa";

const { mapState } = createNamespacedHelpers("beneficiario");

export default {
  name: "ExtratoDespesas",
  components: {
    DadosBeneficiario,
    ExtratoDespesaGrid
  },
  computed: mapState(["dadosBeneficiario"])
};
</script>
